module.exports = __webpack_public_path__ + "static/media/manuel-delivery-icon.0ca0ec4f.svg";